import { render } from "./StatisticByMeasuresCard.vue?vue&type=template&id=bb00262e&scoped=true"
import script from "./StatisticByMeasuresCard.vue?vue&type=script&lang=js"
export * from "./StatisticByMeasuresCard.vue?vue&type=script&lang=js"

import "./StatisticByMeasuresCard.vue?vue&type=style&index=0&id=bb00262e&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb00262e"]])

export default __exports__